import React from 'react';
import Refresh2Icon from '../../atoms/Icons/Refresh2Icon';

export default function GlobalErrorListCard({
  isRefetch,
  refetch,
}: {
  isRefetch: boolean;
  refetch: () => void;
}) {
  return (
    <div className="w-full flex justify-center items-center p-6">
      <div className="max-w-[296px] w-full">
        <p className="text-center mb-1 font-semibold text-black">Terjadi Gangguan</p>
        <p className="text-center text-black text-sm mb-4">
          Mohon cek koneksi jaringan/internet Anda dan coba lagi dalam beberapa saat
        </p>
        <button
          className="flex items-center gap-2 justify-center w-full"
          onClick={refetch}
          disabled={isRefetch}
        >
          <Refresh2Icon className={isRefetch ? 'animate-spin' : ''} />{' '}
          {!isRefetch && <span>Coba Lagi</span>}
        </button>
      </div>
    </div>
  );
}
